function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import { renderIconButton } from './constants';
var COPY_TIMEOUT = 1000;

var CopyButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CopyButton, _PureComponent);

  function CopyButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasCopied: false
    });

    _defineProperty(_assertThisInitialized(_this), "_createClipboard", function (value) {
      // by using Clipboard library we have to pass a selector or DOM node
      // that is going to be used as trigger to listen the click event and
      // execute the 'text' callback in where we are going to pass the text
      // value passed in on the component's props
      if (_this._componentNode) {
        _this._clipboard = new Clipboard(_this._componentNode, {
          container: _this._componentNode,
          text: function text() {
            return value;
          }
        });

        _this._clipboard.on('success', _this._handleCopyToClipboardSuccess.bind(_assertThisInitialized(_this)));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_setRef", function (componentNode) {
      if (componentNode) {
        _this._componentNode = componentNode;
      }
    });

    return _this;
  }

  _createClass(CopyButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;

      this._createClipboard(value);

      this._isMounted = true;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var value = _ref.value;

      this._createClipboard(value);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this._clipboard) {
        this._clipboard.destroy();
      }
    }
  }, {
    key: "_handleCopyToClipboardSuccess",
    value: function _handleCopyToClipboardSuccess() {
      var _this2 = this;

      var onCopyClick = this.props.onCopyClick;
      this.setState({
        hasCopied: true
      });
      setTimeout(function () {
        if (_this2._isMounted) {
          _this2.setState({
            hasCopied: false
          });
        }
      }, COPY_TIMEOUT);

      if (onCopyClick) {
        onCopyClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var render = this.props.render;
      var hasCopied = this.state.hasCopied;
      return React.createElement("span", {
        className: "eds-copy-button",
        ref: this._setRef
      }, render(hasCopied));
    }
  }]);

  return CopyButton;
}(PureComponent);

_defineProperty(CopyButton, "propTypes", {
  /**
   * The text to copy
   */
  value: PropTypes.string.isRequired,

  /**
   * Callback function called if the user clicks on the copy button
   */
  onCopyClick: PropTypes.func,

  /**
   * Render function for the copy button contents (defaults to an Icon Button with copy icon)
   */
  render: PropTypes.func
});

_defineProperty(CopyButton, "defaultProps", {
  render: renderIconButton
});

export { CopyButton as default };